import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AceiteVolumeParcialFornecedor from "../aceite-volume-parcial-fornecedor";
import RecusaFornecedor from "./../recusa-fornecedor";
import intl from "react-intl-universal";
import "./aceite-volume-fornecedor.css";
import Button from "components/button";
import { useGlobalContext } from "hooks/useGlobalContext";
import AceiteVolumeParcialFornecedorModal from "../aceite-volume-parcial-fornecedor-modal";
import ModalDialog from "../../modal-dialog";
import {
  aceiteAtualizado,
  postCreateDeltaOrder,
  getVolumeOrdersFeatureFlag,
} from "../../cards-obsolete/orders-vision.service";
import { formatErrorMessage } from "utils/handle-error";
import { formatNumber } from "utils/format";

const VOLUME_RECUSADO_REDISTRIBUIDO = 64;

const AceiteVolumeFornecedor = (props) => {
  const {
    quantidade,
    idPedido,
    idFamiliaRotuladaCentro,
    data,
    refreshTimeLine,
    startLoading,
    stopLoading,
    recusa,
    aceiteTotal,
    disabled,
  } = props;

  const [showAceiteParcial, setShowAceiteParcial] = useState(false);
  const [showRecusa, setShowRecusa] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentQuantity, setCurrentQuantity] = useState(
    parseFloat(quantidade)
  );
  const [disableButtons, setDisableButtons] = useState(false);
  const [futureFlagDelta, setFutureFlagDelta] = useState(false);

  const { showFeedback } = useGlobalContext();

  useEffect(() => {
    const getFutureFlag = async () => {
      try {
        const flag = await getVolumeOrdersFeatureFlag();

        setFutureFlagDelta(flag);
      } catch {
        setFutureFlagDelta(false);
      }
    };

    getFutureFlag();
  }, []);

  const HandleShowAceiteParcial = () => {
    setShowAceiteParcial(true);
  };

  const HandleHideAceiteParcial = () => {
    setShowAceiteParcial(false);
  };

  const HandleShowRecusa = () => {
    setShowRecusa(true);
  };

  const HandleHideRecusa = () => {
    setShowRecusa(false);
  };

  const handleSaveAsync = async (dto) => {
    startLoading();

    try {
      await aceiteAtualizado(dto);

      showFeedback(
        intl.get("stocks.timeline.feedback.acceptPartialVolumeSent")
      );
    } catch (e) {
      showFeedback(formatErrorMessage(e));

      return;
    } finally {
      stopLoading();
    }

    checkDeltaAvailableVolume(dto);
  };

  const handleSalveDeltaVolumeAsync = async (dto) => {
    const { acceptVolumeOrder, ...newObjt } = dto;

    const dtoDelta = { ...newObjt, VolumeOrderOriginId: idPedido };

    startLoading();

    try {
      await postCreateDeltaOrder(dtoDelta);

      showFeedback(
        intl.get("stocks.timeline.feedback.acceptPartialVolumeSent")
      );
    } catch (e) {
      showFeedback(formatErrorMessage(e));
      return;
    } finally {
      stopLoading();
    }

    stopLoading();

    checkDeltaAvailableVolume(dtoDelta);
  };

  const checkDeltaAvailableVolume = (dto) => {
    if (!futureFlagDelta) {
      refreshTimeLine();
      return;
    }

    if (openModal) {
      setOpenModal(false);
    }

    if (parseFloat(dto.volumeOrder.VolumeAceito) < currentQuantity) {
      setOpenDialog(true);
      setCurrentQuantity((prev) => {
        return prev - parseFloat(dto.volumeOrder.VolumeAceito);
      });

      return;
    }

    refreshTimeLine();
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    if (currentQuantity > 0) {
      setOpenDialog(true);
    }
  };

  const handleCloseModalRefuse = () => {
    setOpenDialog(false);
    setOpenModal(false);

    recusa(
      idPedido,
      "Volume recusado e redistribuido",
      VOLUME_RECUSADO_REDISTRIBUIDO,
      currentQuantity,
      false
    );

    refreshTimeLine();
  };

  const handleFullAcceptance = () => {
    setDisableButtons(true);
    aceiteTotal(idPedido);

    setTimeout(() => {
      setDisableButtons(false);
    }, 2000);
  }

  return (
    <div className="negotiation-line-volume">
      {showAceiteParcial && (
        <AceiteVolumeParcialFornecedor
          quantidadeProposta={quantidade}
          handleCancel={HandleHideAceiteParcial}
          idPedido={idPedido}
          idFamiliaRotuladaCentro={idFamiliaRotuladaCentro}
          data={data}
          showFeedback={showFeedback}
          onSave={handleSaveAsync}
        />
      )}

      <AceiteVolumeParcialFornecedorModal
        quantidadeProposta={currentQuantity}
        handleCancel={handleCloseModal}
        idPedido={0}
        idFamiliaRotuladaCentro={idFamiliaRotuladaCentro}
        data={{ ...data, Quantidade: currentQuantity }}
        open={openModal}
        showJustification={true}
        onSave={handleSalveDeltaVolumeAsync}
      />

      <ModalDialog
        onConfirm={() => {
          setOpenDialog(false);
          setOpenModal(true);
        }}
        onRequestClose={() => {
          handleCloseModalRefuse();
        }}
        textMessage={intl.get("stocks.timeline.reallocationModal.warningText")}
        title={
          <div>
            <p>{intl.get("stocks.timeline.reallocationModal.title")}</p>
            <p>
              {intl.get("stocks.timeline.reallocationModal.volumeLabel")}
              {formatNumber(currentQuantity)}
            </p>
          </div>
        }
        isOpen={openDialog}
      />

      {showRecusa && (
        <RecusaFornecedor
          handleCancel={HandleHideRecusa}
          idPedido={idPedido}
          recusa={recusa}
        />
      )}

      {!showAceiteParcial && !showRecusa && (
        <div className="event-action-volume">
          <Button
            value={intl.get("stocks.timeline.refuse")}
            onClick={HandleShowRecusa}
            buttonType="danger"
            className="button"
            disabled={disabled || disableButtons}
          />
          <Button
            value={intl.get("stocks.timeline.acceptPartial")}
            onClick={HandleShowAceiteParcial}
            buttonType="default"
            className="button"
            disabled={disabled || disableButtons}
          />
          <Button
            value={intl.get("stocks.timeline.accept")}
            onClick={() => handleFullAcceptance()}
            buttonType="primary"
            className="button"
            disabled={disabled || disableButtons}
          />
        </div>
      )}
    </div>
  );
};

AceiteVolumeFornecedor.propTypes = {
  idPedido: PropTypes.number,
  aceiteTotal: PropTypes.func.isRequired,
  recusa: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  quantidade: PropTypes.number.isRequired,
  idFamiliaRotuladaCentro: PropTypes.string,
  data: PropTypes.any,
  refreshTimeLine: PropTypes.any,
  startLoading: PropTypes.any,
  stopLoading: PropTypes.any,
};

export default AceiteVolumeFornecedor;
